import { Fragment, useRef, useState } from "react";
import { Icon } from "@iconify/react";
import LayoutHome from "../layouts/LayoutHome";
import TraitGroup from "../partials/gallery/TraitGroup";
import InfiniteScroll from "@meikidd/react-infinite-scroller";
import CollectionLoader from "../partials/loader/CollectionLoader";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { useEffect } from "react";
import _debounce from "lodash/debounce";
import Traits from "../data/traits.json";
import { useCallback } from "react";
import { Dialog, Menu, Transition } from "@headlessui/react";
import TraitsIcon from "../partials/icons/TraitsIcon";
import useEmblaCarousel from "embla-carousel-react";
import TraitInfo from "../partials/gallery/TraitInfo";
import TraitSelected from "../partials/gallery/TraitSelected";
import "react-lazy-load-image-component/src/effects/blur.css";
import ExperiencePoint from "../partials/miawwhalla/ExperiencePoint";

function Gallery() {
  const infiniteRef = useRef();
  const [emblaRef] = useEmblaCarousel();
  const [showFilter, setShowFilter] = useState(false);
  const [collectionList, setCollectionList] = useState([]);
  const [hasMoreItems, setHasMoreItems] = useState(true);
  const [preview, setPreview] = useState("");
  const [resetTraits, setResetTraits] = useState();
  const [sorting, setSorting] = useState({ by: "id", type: "asc", text: "ID: low to high" });

  const [search, setSearch] = useState("");
  const [newSearch, setNewSearch] = useState(false);
  const [traits, setTraits] = useState({
    race: "",
    background: "",
    cloth: "",
    eyes: "",
    hand: "",
    head: "",
    mouth: "",
    legendary: "",
  });

  const handleSearch = useCallback(
    _debounce((e) => {
      setNewSearch(true);
      if (infiniteRef.current) {
        infiniteRef.current.pageLoaded = 1;
      }
      setSearch(e.target.value);
    }, 1000),
    []
  );

  useEffect(() => {
    if (search !== "" || traits !== "" || sorting !== "") {
      loadCollectionList(1);
    }
  }, [search, traits, sorting]);

  const parseTraits = (data) => {
    let queryString = "";
    for (const key in data) {
      if (data[key] !== undefined && data[key] !== "") {
        queryString += `&${key}=${data[key]}`;
      }
    }
    return queryString;
  };

  const loadCollectionList = (page) => {
    setNewSearch(false);
    const queryString = parseTraits(traits);
    const url = `${process.env.REACT_APP_KHUGA_API_BASE_URL}/galleries?sortBy=${sorting.by}&sortType=${sorting.type}&page=${page}&perPage=12${queryString}${
      search !== "" ? "&search=" + search : ""
    }`;

    fetch(url)
      .then(function (response) {
        return response.json();
      })
      .then((data) => {
        const newList = newSearch ? data?.data : collectionList.concat(data?.data);
        setCollectionList(newList);
        if (data?.data?.length === 0) {
          setHasMoreItems(false);
        } else {
          setHasMoreItems(true);
        }
      })
      .catch(function (err) {
        console.log(err);
      });
  };

  const handleTraitChanges = (id, data) => {
    window.scrollTo(0, 0);
    setTimeout(
      () => {
        let obj = {};
        obj[id] = data.join(",");

        setNewSearch(true);
        if (infiniteRef.current) {
          infiniteRef.current.pageLoaded = 1;
        }
        setTraits((prev) => ({ ...prev, ...obj }));
      },
      window.scrollY > 100 ? 1000 : 0
    );
  };

  const handleResetTraits = (id, value) => {
    setResetTraits({ id: id, value: value });
  };

  const handleSorting = (by, type, text) => {
    setNewSearch(true);
    if (infiniteRef.current) {
      infiniteRef.current.pageLoaded = 1;
    }
    setSorting({ by: by, type: type, text: text });
  };

  return (
    <LayoutHome background="bg-[#F4F4F4]">
      <div className="w-full mx-auto px-4 md:px-10 relative pt-16 bg-[#F4F4F4]">
        <div className="fixed md:hidden bottom-2 inset-x-0 z-20">
          <div className="flex justify-center items-center space-x-2">
            {showFilter ? (
              <>
                <div
                  className="relative hover:opacity-90 hover:shadow transition-all cursor-pointer"
                  onClick={() => setShowFilter((showFilter) => !showFilter)}
                >
                  <img src={`${process.env.PUBLIC_URL}/images/button/filter-dark.webp`} alt="Menu" className="h-11 mx-auto" />
                  <div className="absolute left-0 top-0 w-full text-center mt-2 text-white font-cursive">
                    <div className="flex justify-center items-center space-x-2">
                      <span>x</span>
                      <span>Cancel</span>
                    </div>
                  </div>
                </div>
                <div
                  className="relative hover:opacity-90 hover:shadow transition-all cursor-pointer"
                  onClick={() => setShowFilter((showFilter) => !showFilter)}
                >
                  <img src={`${process.env.PUBLIC_URL}/images/button/filter-light.webp`} alt="Menu" className="h-11 mx-auto" />
                  <div className="absolute left-0 top-0 w-full text-center mt-2 text-white font-cursive">
                    <div className="flex justify-center items-center space-x-2">
                      <span>Update</span>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <div
                className="relative hover:opacity-90 hover:shadow hover:-translate-y-1 transition-all cursor-pointer"
                onClick={() => setShowFilter((showFilter) => !showFilter)}
              >
                <img src={`${process.env.PUBLIC_URL}/images/button/filter-light.webp`} alt="Menu" className="h-11 mx-auto" />
                <div className="absolute left-0 top-0 w-full text-center mt-2 text-white font-cursive">
                  <div className="flex justify-center items-center space-x-2">
                    <Icon icon="carbon:settings-adjust" className="w-5 h-5" />
                    <span>Filter</span>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="grid grid-cols-12 gap-8 py-10 relative min-h-screen">
          <div
            className={`col-span-12 md:col-span-3 fixed z-10 pt-16 md:pt-0 -left-full inset-y-0 w-full md:relative md:left-0 transition-all bg-[#F4F4F4] ${
              showFilter ? "translate-x-full" : ""
            }`}
          >
            <div className="sticky md:top-24 bg-white md:bg-gray-200 border border-gray-300 p-4 md:p-6 rounded-xl space-y-4 h-[calc(100vh_-_8rem)] overflow-auto">
              <h2 className="font-cursive text-xl">Filter</h2>
              <div className="relative">
                <div className="absolute left-3 top-3">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                    role="img"
                    width="1.5em"
                    height="1.5em"
                    preserveAspectRatio="xMidYMid meet"
                    viewBox="0 0 24 24"
                  >
                    <path
                      fill="none"
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="m21 21l-6-6m2-5a7 7 0 1 1-14 0a7 7 0 0 1 14 0Z"
                    />
                  </svg>
                </div>
                <input type="text" className="w-full p-3 pl-10 bg-transparent border border-gray-300" placeholder="Search" onChange={(e) => handleSearch(e)} />
              </div>
              <div className="divide-y divide-gray-300">
                {Traits.map((item) => (
                  <TraitGroup
                    id={item.id}
                    icon={<TraitsIcon name={item.id} />}
                    title={item.name}
                    items={item.values}
                    expand={false}
                    onChange={handleTraitChanges}
                    resetTraits={resetTraits}
                    key={item.id}
                  />
                ))}
              </div>
            </div>
          </div>
          <div className="col-span-12 md:col-span-9">
            {/* Sort By */}
            <div className="w-full text-right mb-2">
              <Menu as="div" className="relative inline-block text-left">
                <div>
                  <Menu.Button className="inline-flex w-full justify-center items-center gap-2 rounded-md bg-primary-700 px-4 py-2 text-sm font-medium text-white hover:bg-opacity-80 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75">
                    <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" viewBox="0 0 24 24">
                      <path fill="currentColor" d="m18 21l-4-4h3V7h-3l4-4l4 4h-3v10h3M2 19v-2h10v2M2 13v-2h7v2M2 7V5h4v2H2Z" />
                    </svg>
                    <span className="font-bold">{sorting.text}</span>
                  </Menu.Button>
                </div>
                <Transition
                  as={Fragment}
                  enter="transition ease-out duration-100"
                  enterFrom="transform opacity-0 scale-95"
                  enterTo="transform opacity-100 scale-100"
                  leave="transition ease-in duration-75"
                  leaveFrom="transform opacity-100 scale-100"
                  leaveTo="transform opacity-0 scale-95"
                >
                  <Menu.Items className="absolute z-10 right-0 top-8 mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                    <div className="px-1 py-1 ">
                      <Menu.Item>
                        {({ active }) => (
                          <button
                            className={`${active ? "bg-primary-800 text-white" : "text-gray-900"} group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                            onClick={() => {
                              handleSorting("id", "asc", "ID: low to high");
                            }}
                          >
                            ID: low to high
                          </button>
                        )}
                      </Menu.Item>
                      <Menu.Item>
                        {({ active }) => (
                          <button
                            className={`${active ? "bg-primary-800 text-white" : "text-gray-900"} group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                            onClick={() => {
                              handleSorting("id", "desc", "ID: high to low");
                            }}
                          >
                            ID: high to low
                          </button>
                        )}
                      </Menu.Item>
                      <Menu.Item>
                        {({ active }) => (
                          <button
                            className={`${active ? "bg-primary-800 text-white" : "text-gray-900"} group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                            onClick={() => {
                              handleSorting("rank", "asc", "Rank: low to high");
                            }}
                          >
                            Rank: low to high
                          </button>
                        )}
                      </Menu.Item>
                      <Menu.Item>
                        {({ active }) => (
                          <button
                            className={`${active ? "bg-primary-800 text-white" : "text-gray-900"} group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                            onClick={() => {
                              handleSorting("rank", "desc", "Rank: high to low");
                            }}
                          >
                            Rank: high to low
                          </button>
                        )}
                      </Menu.Item>
                      <Menu.Item>
                        {({ active }) => (
                          <button
                            className={`${active ? "bg-primary-800 text-white" : "text-gray-900"} group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                            onClick={() => {
                              handleSorting("level", "asc", "EXP: low to high");
                            }}
                          >
                            EXP: low to high
                          </button>
                        )}
                      </Menu.Item>
                      <Menu.Item>
                        {({ active }) => (
                          <button
                            className={`${active ? "bg-primary-800 text-white" : "text-gray-900"} group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                            onClick={() => {
                              handleSorting("level", "desc", "EXP: high to low");
                            }}
                          >
                            EXP: high to low
                          </button>
                        )}
                      </Menu.Item>
                    </div>
                  </Menu.Items>
                </Transition>
              </Menu>
            </div>

            {/* Selected Traits */}
            {traits !== "" && (
              <div className="w-full mb-6 items-center">
                {traits?.race &&
                  traits.race.split(",").map((i) => (
                    <div onClick={() => handleResetTraits("race", i)} className="inline-block">
                      <TraitSelected name="Race" value={i} />
                    </div>
                  ))}
                {traits?.background &&
                  traits.background.split(",").map((i) => (
                    <div onClick={() => handleResetTraits("background", i)} className="inline-block">
                      <TraitSelected name="Background" value={i} />
                    </div>
                  ))}
                {traits?.cloth &&
                  traits.cloth.split(",").map((i) => (
                    <div onClick={() => handleResetTraits("cloth", i)} className="inline-block">
                      <TraitSelected name="Cloth" value={i} />
                    </div>
                  ))}
                {traits?.eyes &&
                  traits.eyes.split(",").map((i) => (
                    <div onClick={() => handleResetTraits("eyes", i)} className="inline-block">
                      <TraitSelected name="Eyes" value={i} />
                    </div>
                  ))}
                {traits?.hand &&
                  traits.hand.split(",").map((i) => (
                    <div onClick={() => handleResetTraits("hand", i)} className="inline-block">
                      <TraitSelected name="Hand" value={i} />
                    </div>
                  ))}
                {traits?.head &&
                  traits.head.split(",").map((i) => (
                    <div onClick={() => handleResetTraits("head", i)} className="inline-block">
                      <TraitSelected name="Head" value={i} />
                    </div>
                  ))}
                {traits?.mouth &&
                  traits.mouth.split(",").map((i) => (
                    <div onClick={() => handleResetTraits("mouth", i)} className="inline-block">
                      <TraitSelected name="Mouth" value={i} />
                    </div>
                  ))}
                {traits?.legendary &&
                  traits.legendary.split(",").map((i) => (
                    <div onClick={() => handleResetTraits("legendary", i)} className="inline-block">
                      <TraitSelected name="Legendary" value={i} />
                    </div>
                  ))}

                {(traits?.race != "" ||
                  traits?.background != "" ||
                  traits?.cloth != "" ||
                  traits?.eyes != "" ||
                  traits?.hand != "" ||
                  traits?.head != "" ||
                  traits?.mouth != "" ||
                  traits?.legendary != "") && (
                  <button
                    onClick={() => handleResetTraits("clear", "all")}
                    className="inline-flex items-center gap-2 bg-transparent px-3 py-2 rounded-md hover:contrast-75 text-sm font-semibold border border-transparent mr-2 mb-2"
                  >
                    <span>Clear All</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                      <path fill="none" stroke="currentColor" stroke-linecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                )}
              </div>
            )}

            <InfiniteScroll
              ref={infiniteRef}
              threshold={0}
              pageStart={0}
              loadMore={loadCollectionList}
              hasMore={hasMoreItems}
              loader={
                <div key={0} className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
                  <CollectionLoader />
                  <CollectionLoader />
                  <CollectionLoader />
                  <CollectionLoader />
                </div>
              }
            >
              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
                {collectionList.map((item, i) => (
                  <div onClick={() => setPreview(item)} className="text-center cursor-pointer group w-full aspect-square" key={i}>
                    <div className="w-full aspect-square overflow-hidden rounded-xl group-hover:shadow-xl transition-all">
                      <div className="group-hover:scale-110 transition-all duration-300">
                        <LazyLoadImage
                          key={item.id}
                          src={`https://khuga.io/khuga-preview/${item.id}.webp`}
                          // placeholderSrc="/images/placeholder.webp"
                          placeholder={<CollectionLoader />}
                          effect="blur"
                          alt={item.name}
                          className="w-full aspect-square rounded-xl mb-1"
                        />
                      </div>
                    </div>
                    <div className="flex justify-center items-center">
                      <h3 className="text-sm">
                        <strong>{item.name}</strong>
                      </h3>
                    </div>
                  </div>
                ))}
              </div>
            </InfiniteScroll>
            {hasMoreItems ? "" : <div className="text-center py-4">All data has been loaded</div>}
          </div>
        </div>
      </div>

      <Transition appear show={preview != ""} as={Fragment}>
        <Dialog as="div" className="relative z-20" onClose={() => setPreview("")}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25 backdrop-blur" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel
                  className={`w-full max-w-6xl transform rounded-lg text-left align-middle shadow-xl transition-all relative bg-${
                    preview?.background === "Dark Blue" ? "DarkBlue" : preview?.background
                  }`}
                >
                  {/* <div className="absolute inset-0 bg-testing"></div> */}
                  <button className="absolute z-10 -right-5 -top-5 bg-red-500 text-white p-3 rounded-full shadow-md" onClick={() => setPreview("")}>
                    <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" viewBox="0 0 24 24">
                      <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>

                  <div className="relative grid grid-cols-1 md:grid-cols-2">
                    <div className={`pr-0 mb-4 md:mb-0 relative overflow-hidden ${preview?.legendary && "img-legendary"}`}>
                      {/* {preview?.legendary && (
                        <>
                          <div className="pointer-events-none absolute z-10 inset-0 aspect-square rounded-l-lg border-2 border-[#FFC500]"></div>
                          <div className="pointer-events-none absolute z-10 inset-px aspect-square rounded-l-lg animate-pulse neon-legendary"></div>
                        </>
                      )} */}
                      {preview?.image_url ? (
                        <img
                          src={`https://gateway.ipfs.io/ipfs/QmabZm7rqjr3dc7mmPHzXZRLMDWnu9iBAYjtiq3koBjjwU/${preview?.id}.png`}
                          alt=""
                          className="w-full aspect-square rounded-l-lg"
                        />
                      ) : (
                        <div className="w-full aspect-square bg-transparent"></div>
                      )}
                    </div>
                    <div className={`px-6 pt-6 md:pb-6 pb-40 relative ${preview?.legendary ? "bg-legendary" : "bg-" + preview?.background}`}>
                      {/* <div className="absolute inset-0 bg-testing"></div>
                      <div className="absolute inset-0 backdrop-blur-md bg-black/10"></div> */}
                      <div className="w-full">
                        {preview?.id && (
                          <div className="relative flex items-center justify-between bg-black/90 p-3 mb-4 rounded text-white">
                            <h3 className="font-cursive text-xl">{`Khuga #${preview?.id ?? ""}`}</h3>
                            <div>
                              <a
                                href={`https://opensea.io/assets/ethereum/0xf4768ee87bd5e6a84c3bd4ae6cc9c3f4305bf376/${preview?.id}`}
                                target="_blank"
                                className="inline-block p-2"
                              >
                                <svg xmlns="http://www.w3.org/2000/svg" className="w-8 h-8" viewBox="0 0 24 24">
                                  <path
                                    fill="currentColor"
                                    d="M12 0C5.374 0 0 5.374 0 12s5.374 12 12 12s12-5.374 12-12S18.629 0 12 0ZM5.92 12.403l.051-.081l3.123-4.884a.107.107 0 0 1 .187.014c.52 1.169.972 2.623.76 3.528c-.088.372-.335.876-.614 1.342a2.405 2.405 0 0 1-.117.199a.106.106 0 0 1-.09.045H6.013a.106.106 0 0 1-.091-.163zm13.914 1.68a.109.109 0 0 1-.065.101c-.243.103-1.07.485-1.414.962c-.878 1.222-1.548 2.97-3.048 2.97H9.053a4.019 4.019 0 0 1-4.013-4.028v-.072c0-.058.048-.106.108-.106h3.485c.07 0 .12.063.115.132c-.026.226.017.459.125.67c.206.42.636.682 1.099.682h1.726v-1.347H9.99a.11.11 0 0 1-.089-.173l.063-.09c.16-.231.391-.586.621-.992c.156-.274.308-.566.43-.86c.024-.052.043-.107.065-.16c.033-.094.067-.182.091-.269a4.57 4.57 0 0 0 .065-.223c.057-.25.081-.514.081-.787c0-.108-.004-.221-.014-.327c-.005-.117-.02-.235-.034-.352a3.415 3.415 0 0 0-.048-.312a6.494 6.494 0 0 0-.098-.468l-.014-.06c-.03-.108-.056-.21-.09-.317a11.824 11.824 0 0 0-.328-.972a5.212 5.212 0 0 0-.142-.355c-.072-.178-.146-.339-.213-.49a3.564 3.564 0 0 1-.094-.197a4.658 4.658 0 0 0-.103-.213c-.024-.053-.053-.104-.072-.152l-.211-.388c-.029-.053.019-.118.077-.101l1.32.357h.01l.173.05l.192.054l.07.019v-.783c0-.379.302-.686.679-.686a.66.66 0 0 1 .477.202a.69.69 0 0 1 .2.484V6.65l.141.039c.01.005.022.01.031.017c.034.024.084.062.147.11c.05.038.103.086.165.137a10.351 10.351 0 0 1 .574.504c.214.199.454.432.684.691c.065.074.127.146.192.226c.062.079.132.156.19.232c.079.104.16.212.235.324c.033.053.074.108.105.161c.096.142.178.288.257.435c.034.067.067.141.096.213c.089.197.159.396.202.598a.65.65 0 0 1 .029.132v.01c.014.057.019.12.024.184a2.057 2.057 0 0 1-.106.874c-.031.084-.06.17-.098.254c-.075.17-.161.343-.264.502c-.034.06-.075.122-.113.182c-.043.063-.089.123-.127.18a3.89 3.89 0 0 1-.173.221c-.053.072-.106.144-.166.209c-.081.098-.16.19-.245.278c-.048.058-.1.118-.156.17c-.052.06-.108.113-.156.161c-.084.084-.15.147-.208.202l-.137.122a.102.102 0 0 1-.072.03h-1.051v1.346h1.322c.295 0 .576-.104.804-.298c.077-.067.415-.36.816-.802a.094.094 0 0 1 .05-.03l3.65-1.057a.108.108 0 0 1 .138.103z"
                                  />
                                </svg>
                              </a>
                            </div>
                          </div>
                        )}

                        <div className="block md:hidden embla mb-4" ref={emblaRef}>
                          <div className="embla__container gap-2">
                            {preview?.race && (
                              <div className="embla__slide">
                                <TraitInfo id="race" name="Race" value={preview?.race} />
                              </div>
                            )}
                            {preview?.cloth && (
                              <div className="embla__slide">
                                <TraitInfo id="cloth" name="Cloth" value={preview?.cloth} />
                              </div>
                            )}
                            {preview?.eyes && (
                              <div className="embla__slide">
                                <TraitInfo id="eyes" name="Eyes" value={preview?.eyes} />
                              </div>
                            )}
                            {preview?.hand && (
                              <div className="embla__slide">
                                <TraitInfo id="hand" name="Hand" value={preview?.hand} />
                              </div>
                            )}
                            {preview?.head && (
                              <div className="embla__slide">
                                <TraitInfo id="head" name="Head" value={preview?.head} />
                              </div>
                            )}
                            {preview?.mouth && (
                              <div className="embla__slide">
                                <TraitInfo id="mouth" name="Mouth" value={preview?.mouth} />
                              </div>
                            )}
                            {preview?.background && (
                              <div className="embla__slide">
                                <TraitInfo id="background" name="Background" value={preview?.background} />
                              </div>
                            )}
                            {preview?.legendary && (
                              <div className="embla__slide">
                                <TraitInfo id="legendary" name="Legendary" value={preview?.legendary} />
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="hidden relative md:grid grid-cols-1 md:grid-cols-2 gap-1 sm:gap-2 md:gap-4">
                          {preview?.race && <TraitInfo id="race" name="Race" value={preview?.race} />}
                          {preview?.cloth && <TraitInfo id="cloth" name="Cloth" value={preview?.cloth} />}
                          {preview?.eyes && <TraitInfo id="eyes" name="Eyes" value={preview?.eyes} />}
                          {preview?.hand && <TraitInfo id="hand" name="Hand" value={preview?.hand} />}
                          {preview?.head && <TraitInfo id="head" name="Head" value={preview?.head} />}
                          {preview?.mouth && <TraitInfo id="mouth" name="Mouth" value={preview?.mouth} />}
                          {preview?.background && <TraitInfo id="background" name="Background" value={preview?.background} />}
                          {preview?.legendary && <TraitInfo id="legendary" name="Legendary" value={preview?.legendary} />}
                        </div>
                      </div>

                      <div className="absolute left-6 bottom-6 right-6 grid grid-cols-1 md:grid-cols-2 gap-1 sm:gap-2 md:gap-4">
                        {/* TODO: Replace id to NFT ID */}
                        <ExperiencePoint className="mx-auto w-full" id={preview?.id} dataXp={preview?.experience_points} />
                        <div className="bg-black/20 py-4 px-2 rounded flex items-center gap-2 w-full text-center">
                          <p className="font-bold text-white">Rank: {preview?.rank} by</p>
                          <a href="https://tinyastro.io/analytics/0xf4768ee87bd5e6a84c3bd4ae6cc9c3f4305bf376?tab=rarity" target="_blank">
                            <img src="/images/logo/tinyastro.svg" alt="Logo" className="h-5" />
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>

      <footer className="bg-white text-center py-5 text-sm">©2023 Khuga by Khuga Labs</footer>
    </LayoutHome>
  );
}

export default Gallery;
